import axios from 'axios';
import config from '../config';

export const fetchStates = () =>
  axios.request({
    method: 'get',
    url: `${config.providerApiInternal}/states`,
  });



// WEBPACK FOOTER //
// ./src/api/states.js